module.exports = __webpack_public_path__ + "static/media/img_image_1.d4708e3b.png";